// components/AuditLogTable.js
import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

const AuditLogTable = ({ logs }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Log ID</TableCell>
          <TableCell>User ID</TableCell>
          <TableCell>Event Type</TableCell>
          <TableCell>Event Details</TableCell>
          <TableCell>Timestamp</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {logs.map((log) => (
          <TableRow key={log.log_id}>
            <TableCell>{log.log_id}</TableCell>
            <TableCell>{log.user_id || 'System'}</TableCell>
            <TableCell>{log.event_type}</TableCell>
            <TableCell>{log.event_details}</TableCell>
            <TableCell>{new Date(log.created_at).toLocaleString()}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

AuditLogTable.propTypes = {
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      log_id: PropTypes.number.isRequired,
      user_id: PropTypes.string,
      event_type: PropTypes.string.isRequired,
      event_details: PropTypes.string,
      created_at: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default AuditLogTable;